import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect } from "react";
import { useForm } from "react-hook-form";

import type { BasicCustomMailSetting } from "@/lib/gql/__generated__/graphql";

import { basicCustomMailSettingSchema } from "../../schema/validation-schema";

import type { BasicCustomMailSettingFormData } from "../../schema/validation-schema";
import type { UseFormReturn } from "react-hook-form";

type Props = {
	hotelID: string;
	customMailSetting?: BasicCustomMailSetting;
};

export const useCustomMailSettingForm = ({
	hotelID,
	customMailSetting,
}: Props): { form: UseFormReturn<BasicCustomMailSettingFormData> } => {
	const defaultValues: BasicCustomMailSettingFormData = {
		id: hotelID,
		mailFooterExternalLink: customMailSetting?.mailFooterExternalLink ?? "",
		forReservation: {
			atCreated: {
				text: customMailSetting?.forReservation?.atCreated?.text ?? "",
			},
			atUpdated: {
				text: customMailSetting?.forReservation?.atUpdated?.text ?? "",
			},
			atCanceled: {
				text: customMailSetting?.forReservation?.atCanceled?.text ?? "",
			},
			atCheckInBefore_07days: {
				text: customMailSetting?.forReservation?.atCheckInBefore_07days?.text ?? "",
				shouldSendEmail: customMailSetting?.forReservation?.atCheckInBefore_07days.shouldSendEmail ?? false,
			},
			atCheckInBefore_01days: {
				text: customMailSetting?.forReservation?.atCheckInBefore_01days?.text ?? "",
				shouldSendEmail: customMailSetting?.forReservation?.atCheckInBefore_01days?.shouldSendEmail ?? false,
			},
			atCheckInBefore_00days: {
				text: customMailSetting?.forReservation?.atCheckInBefore_00days?.text ?? "",
				shouldSendEmail: customMailSetting?.forReservation?.atCheckInBefore_00days?.shouldSendEmail ?? false,
			},
			atCheckOutAfter_01days: {
				text: customMailSetting?.forReservation?.atCheckOutAfter_01days?.text ?? "",
				shouldSendEmail: customMailSetting?.forReservation?.atCheckOutAfter_01days?.shouldSendEmail ?? false,
			},
			atRequest: {
				text: customMailSetting?.forReservation?.atRequest?.text ?? "",
			},
			atConfirmed: {
				text: customMailSetting?.forReservation?.atConfirmed?.text ?? "",
			},
			atDeclined: {
				text: customMailSetting?.forReservation?.atDeclined?.text ?? "",
			},
		},
		forShopping: {
			atCreated: {
				text: customMailSetting?.forShopping?.atCreated?.text ?? "",
			},
		},
	} satisfies BasicCustomMailSettingFormData;

	const form: UseFormReturn<BasicCustomMailSettingFormData> = useForm<BasicCustomMailSettingFormData>({
		mode: "onChange",
		resolver: zodResolver(basicCustomMailSettingSchema),
		defaultValues,
	});

	const { trigger } = form;

	// 初回バリデーション実行
	useEffect(() => {
		trigger();
	}, [trigger]);

	return { form };
};
